import { apiClient } from './apiClient';
import {
  JobLead,
  CreateJobLeadPayload,
  PaginatedResponse,
  JobLeadStatus,
} from '../types';

export const jobLeadService = {
  /** Surveyor submits a new job lead for admin review */
  async create(payload: CreateJobLeadPayload): Promise<JobLead> {
    const { data } = await apiClient.post<JobLead>('/job-leads/', payload);
    return data;
  },

  /** Surveyor fetches their own submitted leads */
  async listMine(params?: {
    status?: JobLeadStatus;
    page?: number;
  }): Promise<PaginatedResponse<JobLead>> {
    const { data } = await apiClient.get<PaginatedResponse<JobLead>>('/job-leads/', { params });
    return data;
  },

  /** Approved advertised leads near the current surveyor/location. Client phone is hidden by the API. */
  async listNearby(params?: {
    latitude?: number;
    longitude?: number;
    radius_km?: number;
    page?: number;
  }): Promise<PaginatedResponse<JobLead>> {
    const { data } = await apiClient.get<PaginatedResponse<JobLead>>('/job-leads/nearby/', { params });
    return data;
  },

  /** Single lead detail */
  async getDetail(id: string): Promise<JobLead> {
    const { data } = await apiClient.get<JobLead>(`/job-leads/${id}/`);
    return data;
  },
  async bid(id: string): Promise<{ chat_room_id: string; detail: string }> {
    const { data } = await apiClient.post<{ chat_room_id: string; detail: string }>(`/job-leads/${id}/bid/`);
    return data;
  },
  async resubmit(id: string): Promise<JobLead> {
    const { data } = await apiClient.post<JobLead>(`/job-leads/${id}/resubmit/`);
    return data;
  },
};
